import { CreateAllData } from '@/apiError/apiCreate';
import { UpdateAllData } from '@/apiError/apiUpdate';
import { VoucherTable } from '@/pages/vouchers/VoucherComponent';
import CustomSelect from '@/utils/search/Search';
import { DeleteFilled, PlusCircleOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const UserCompanyMappingCreate = () => {
  const [dataSource, setDataSource] = useState([
    {
      key: 0,
      company: null,
      branch: null,
      user: null,
    },
  ]);
  const rowTemplate = { company: null, branch: null, user: null };

  const handleAdd = () => {
    const newData = { key: dataSource?.length + 1, ...rowTemplate };
    setDataSource((prevData) => {
      const updatedData = [...prevData, newData];
      return updatedData;
    });
  };

  const handleDelete = (key) => {
    if (dataSource.length === 1) {
      const resetRow = { key, ...rowTemplate };
      setDataSource([resetRow]);
      setSelectedItems((prevItems) => ({
        ...prevItems,
        [key]: [],
      }));
    } else {
      const updatedDataSource = dataSource?.filter((item) => item.key !== key);
      setDataSource(updatedDataSource);
      setSelectedItems((prevItems) => {
        const updatedItems = { ...prevItems };
        delete updatedItems[key];
        return updatedItems;
      });
    }
  };

  const handleSave = (row) => {
    const updatedData = dataSource?.map((item) =>
      item.key === row.key ? { ...item, ...row } : item,
    );
    setDataSource(updatedData);
    setSelectedItems((prevItems) => ({
      ...prevItems,
      [row.key]: [row.from, row.to],
    }));
  };
  const VoucherData = dataSource?.map((data, index) => ({
    sno: index + 1,
    ...data,
  }));

  const handleSubmit = async () => {
    const value = form.getFieldsValue();
    const formattedDate = value.voucherDate.format('YYYY-MM-DD');
    const allData = {
      ...value,
      voucherDate: formattedDate,
      voucherDetails: dataSource,
    };
    try {
      if (id) {
        await UpdateAllData.updateData(
          `account/contra-voucher/${id}/`,
          allData,
        );
      } else {
        await CreateAllData.createItem('account/contra-vouchers/', allData);
      }
      setDataSource([
        {
          key: 0,
          company: null,
          branch: null,
          user: null,
        },
      ]);
      setSelectedItems([]);
    } finally {
    }
  };

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      width: '10%',
      align: 'center',
    },
    {
      title: 'Company',
      dataIndex: 'company',
      align: 'center',
      width: '40%',
      render: (_, record) => (
        <CustomSelect
          placeholder="Select company"
          style={{ width: '100%' }}
          value={record.company}
          onChange={(value) => handleSelectChange(value, record)}
          options={
            cashBankLedgerData?.length
              ? cashBankLedgerData?.map((ledger) => ({
                  key: ledger.referenceId,
                  value: ledger.referenceId,
                  label: ledger.name,
                  disabled:
                    selectedItems.includes(ledger.referenceId) &&
                    record.payFrom !== ledger.referenceId, // Disable if already selected in another row
                }))
              : []
          }
          onAddClick={handleAddClick}
        />
      ),
    },
    {
      title: 'Branch',
      dataIndex: 'branch',
      align: 'center',
      width: '40%',
      render: (_, record) => (
        <CustomSelect
          placeholder="Select branch"
          style={{ width: '100%' }}
          value={record.company}
          onChange={(value) => handleSelectChange(value, record)}
          options={
            cashBankLedgerData?.length
              ? cashBankLedgerData?.map((ledger) => ({
                  key: ledger.referenceId,
                  value: ledger.referenceId,
                  label: ledger.name,
                  disabled:
                    selectedItems.includes(ledger.referenceId) &&
                    record.payFrom !== ledger.referenceId, // Disable if already selected in another row
                }))
              : []
          }
          onAddClick={handleAddClick}
        />
      ),
    },
    {
      title: 'User',
      dataIndex: 'user',
      align: 'center',
      width: '40%',
      render: (_, record) => (
        <CustomSelect
          placeholder="Select user"
          style={{ width: '100%' }}
          value={record.company}
          onChange={(value) => handleSelectChange(value, record)}
          options={
            cashBankLedgerData?.length
              ? cashBankLedgerData?.map((ledger) => ({
                  key: ledger.referenceId,
                  value: ledger.referenceId,
                  label: ledger.name,
                  disabled:
                    selectedItems.includes(ledger.referenceId) &&
                    record.payFrom !== ledger.referenceId, // Disable if already selected in another row
                }))
              : []
          }
          onAddClick={handleAddClick}
        />
      ),
    },

    {
      title: 'Action',
      dataIndex: 'action',
      align: 'center',
      render: (_, record) => (
        <section className="flex gap-1 justify-center">
          <div
            onClick={() => handleAdd(rowTemplate)}
            className="ant-button-edit"
          >
            <Link className="edit">
              <PlusCircleOutlined />
            </Link>
          </div>
          <div
            onClick={() => handleDelete(record.key)}
            className="ant-button-delete"
          >
            {' '}
            <Link className="delete" style={{ color: 'red' }}>
              <DeleteFilled />
            </Link>
          </div>
        </section>
      ),
    },
  ];
  return (
    <div>
      <VoucherTable columns={columns} />
    </div>
  );
};

export default UserCompanyMappingCreate;
